var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSer01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1419 4.0751L11.2586 1.9001C10.5419 1.58343 9.45856 1.58343 8.74189 1.9001L3.85856 4.0751C2.62523 4.6251 2.44189 5.3751 2.44189 5.7751C2.44189 6.1751 2.62523 6.9251 3.85856 7.4751L8.74189 9.6501C9.10023 9.80843 9.55023 9.89176 10.0002 9.89176C10.4502 9.89176 10.9002 9.80843 11.2586 9.6501L16.1419 7.4751C17.3752 6.9251 17.5586 6.1751 17.5586 5.7751C17.5586 5.3751 17.3836 4.6251 16.1419 4.0751Z",
    fill: "#0e131c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99977 14.2001C9.68311 14.2001 9.36644 14.1334 9.07477 14.0084L3.45811 11.5084C2.59977 11.1251 1.93311 10.1001 1.93311 9.15841C1.93311 8.81675 2.20811 8.54175 2.54977 8.54175C2.89144 8.54175 3.16644 8.81675 3.16644 9.15841C3.16644 9.60841 3.54144 10.1917 3.95811 10.3751L9.57477 12.8751C9.84144 12.9917 10.1498 12.9917 10.4164 12.8751L16.0331 10.3751C16.4498 10.1917 16.8248 9.61675 16.8248 9.15841C16.8248 8.81675 17.0998 8.54175 17.4414 8.54175C17.7831 8.54175 18.0581 8.81675 18.0581 9.15841C18.0581 10.0917 17.3914 11.1251 16.5331 11.5084L10.9164 14.0084C10.6331 14.1334 10.3164 14.2001 9.99977 14.2001Z",
    fill: "#0e131c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99977 18.3334C9.68311 18.3334 9.36644 18.2667 9.07477 18.1417L3.45811 15.6417C2.53311 15.2334 1.93311 14.3084 1.93311 13.2917C1.93311 12.95 2.20811 12.675 2.54977 12.675C2.89144 12.675 3.16644 12.95 3.16644 13.2917C3.16644 13.8167 3.47477 14.2917 3.95811 14.5084L9.57477 17.0084C9.84144 17.125 10.1498 17.125 10.4164 17.0084L16.0331 14.5084C16.5081 14.3 16.8248 13.8167 16.8248 13.2917C16.8248 12.95 17.0998 12.675 17.4414 12.675C17.7831 12.675 18.0581 12.95 18.0581 13.2917C18.0581 14.3084 17.4581 15.225 16.5331 15.6417L10.9164 18.1417C10.6331 18.2667 10.3164 18.3334 9.99977 18.3334Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSer01);
export default __webpack_public_path__ + "static/media/ser-01.278941760964f21b307deacb17acca57.svg";
export { ForwardRef as ReactComponent };